import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { AlertController, IonModal, ModalController } from '@ionic/angular';
import { OAuthService } from 'angular-oauth2-oidc';
import { firstValueFrom } from 'rxjs';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { font } from '../util/pdf-fontok/Bitter-Regular-normal';
import { fontB } from '../util/pdf-fontok/Bitter-Bold-normal';
import { EntityPickerModalComponent } from '../components/entity-picker-modal/entity-picker-modal.component';
import { osszegSzoveg } from '../util/penznem';

@Component({
  selector: 'app-tkt',
  templateUrl: './tkt.component.html',
  styleUrls: ['./tkt.component.scss'],
})
export class TktComponent implements OnInit {

  feljegyzesek = []

  /*  ELMÚLT TEVÉKENYSÉGEK.
   *
   *  A lista minden tábort és eseményt mutatott, a réges-régen lezajlottakat is –
   *  így a jelentkezhető programokat ki kellett keresni a múlt közül. Alapból ezért
   *  csak az él, aminek még nincs vége; az elmúltak külön kérésre jönnek.
   *
   *  Ha valaki visszanéz, akkor viszont TANÉVRE kell szűkíteni, különben a lista
   *  évekkel együtt nő. A tanévhatár mindenképpen AUGUSZTUS 31.: a szeptember 1-jén
   *  kezdődő program már a következő tanévhez tartozik.
   */
  elmultakIs = false
  tanev: number = TktComponent.tanevKezdete(new Date())

  /** Egy dátum tanéve = annak az évnek a szeptembere, amelyikbe a nap esik. */
  private static tanevKezdete(d: Date): number {
    return d.getMonth() >= 8 ? d.getFullYear() : d.getFullYear() - 1;
  }
  user$
  loginMode
  userMetadata
  sajatIntezmeny
  uuid
  @ViewChild('feljegyzesmodal') feljegyzesmodal: IonModal;
  f
  gyerekek
  eredeti

  /* ══════════════════════════════════════════════════════════════════════
   *  RÉSZTVEVŐK ÉS BEFIZETÉSEK
   *
   *  A pénztár kérése: a sítáborhoz a „+" gombbal lehessen diákot rendelni, és
   *  rögzíteni, ki mennyit fizetett be (több részletben, akár euróban). A szervező
   *  tanár és a pénztár a teljes listát látja, a család a saját gyermekéét.
   *
   *  A jogot a kiszolgáló dönti el tevékenységenként (backend/tkt-befizetes.js): a
   *  felület a válasz `jog` mezőjét követi, maga nem következtet a jogkörökből.
   * ═══════════════════════════════════════════════════════════════════ */

  /** A megnyitott tevékenység résztvevői (+ kezelőnek a befizetések). */
  reszletek: any = null;
  reszletekToltes = false;
  /** Melyik résztvevő részletei vannak lenyitva. */
  nyitottResztvevo: string | null = null;
  ujReszlet: { datum: string; osszeg: any; megjegyzes: string } = { datum: '', osszeg: null, megjegyzes: '' };
  /** A befizetésről a tanuló értesítést kap (az esemény értesítési csatornáján). */
  reszletErtesites = true;
  /** A „+" gomb választólistája – csak az első megnyitáskor töltjük be. */
  private tanuloLista: any[] | null = null;
  /** Családi nézet: a gyermek(ek) részvételei és befizetései. */
  sajatBefizetesek: any[] = [];

  /*  TANULÓ-KERESŐ (munkatársi nézet, Rinth Krisztina kérése): a név beírására javaslatok,
   *  a kiválasztott tanulónál pedig az összes tevékenysége – ahol résztvevő, vagy ahol már
   *  nem az, de van befizetése. Az összegeket a kiszolgáló csak a kezelt tevékenységeknél adja. */
  kereso = '';
  keresoTanulo: any = null;
  keresoTetelek: any[] = [];
  keresoToltes = false;

  constructor(public oauth: OAuthService, private data: DataService, private http: HttpClient,
              private modalCtrl: ModalController, private alertCtrl: AlertController) { }

  get intezmeny(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  /*  A DIÁK NEM JELENTKEZTET. A naptárban is a szülő adja le a jelentkezést; a diák a
   *  saját részvételét és befizetéseit látja. (A mentés a diák saját körével futna, és
   *  egy üres választás a diákot le is jelentkeztetné.) */
  get diakMode(): boolean { return this.loginMode === 'tanulo'; }

  osszeg(ertek: any, penznem: any): string { return osszegSzoveg(ertek, penznem); }

  /** Az ár a pénznemével és az egységével: „450 € / fő", „65 000 Ft / hét". */
  arSzoveg(f: any): string {
    if (!f?.ar) return '';
    return osszegSzoveg(f.ar, f.ar_penznem) + (f.ar_tipus ? ` / ${f.ar_tipus}` : '');
  }

  allapotCimke(r: any): string {
    if (r && r.resztvevo === false) return 'Korábbi résztvevő';
    switch (r?.allapot) {
      case 'rendezve': return 'Rendezve';
      case 'reszben': return 'Részben fizetve';
      case 'befizetve': return 'Befizetve';
      case 'nincs-ar': return 'Nincs megadott ár';
      default: return 'Nincs befizetés';
    }
  }

  allapotSzin(r: any): string {
    if (r && r.resztvevo === false) return 'medium';
    switch (r?.allapot) {
      case 'rendezve': case 'befizetve': return 'success';
      case 'reszben': return 'warning';
      case 'nincs-ar': return 'medium';
      default: return 'danger';
    }
  }

  /** 0..1 – a haladásjelzőhöz. */
  haladas(r: any): number {
    const ar = Number(r?.ar);
    if (!(ar > 0)) return 0;
    return Math.max(0, Math.min(1, Number(r?.befizetve || 0) / ar));
  }

  get aktivResztvevok(): any[] {
    return (this.reszletek?.resztvevok || []).filter((r: any) => r.resztvevo);
  }

  get korabbiResztvevok(): any[] {
    return (this.reszletek?.resztvevok || []).filter((r: any) => !r.resztvevo);
  }

  get letszamTullepve(): boolean {
    const letszam = Number(this.reszletek?.esemeny?.letszam || 0);
    return letszam > 0 && this.aktivResztvevok.length > letszam;
  }

  private maiNap(): string {
    const d = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  }

  private hibaUzenet(err: any, alap: string): string {
    return err?.error?.error || alap;
  }

  async betoltReszletek() {
    if (!this.f?.id) return;
    this.reszletekToltes = true;
    try {
      this.reszletek = await firstValueFrom(this.http.get<any>(
        `/api/tkt-befizetes/esemeny/${encodeURIComponent(this.f.id)}`, { params: { intezmeny: this.intezmeny } }));
      //  A névsor-PDF és a lista létszáma a kiszolgáló friss állapotából dolgozik.
      this.resztvevokFrissit(this.aktivResztvevok.map((r: any) => r.oktazon),
        Object.fromEntries((this.reszletek?.resztvevok || []).map((r: any) => [r.oktazon, { name: r.nev }])));
    } catch (err) {
      this.reszletek = null;
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült betölteni a résztvevőket.'), 'error');
    } finally {
      this.reszletekToltes = false;
    }
  }

  /** A megnyitott tevékenység és a háttérlista résztvevői egyszerre – ne mondjanak mást. */
  private resztvevokFrissit(jelentkezok: string[], nevek: any = null) {
    if (!this.f) return;
    this.f.jelentkezok = [...jelentkezok];
    if (nevek) this.f.jelentkezok_arr = { ...(this.f.jelentkezok_arr || {}), ...nevek };
    const listaban = (this.feljegyzesek || []).find((x: any) => String(x.id) === String(this.f.id));
    if (listaban) {
      listaban.jelentkezok = [...jelentkezok];
      if (nevek) listaban.jelentkezok_arr = { ...(listaban.jelentkezok_arr || {}), ...nevek };
    }
  }

  /*  KÉT ÚT: iskolai tanuló a választóból, vagy KÜLSŐS (végzett diák, szülő, kísérő)
   *  beírt névvel – nekik nincs oktatási azonosítójuk, de ugyanúgy résztvevők és fizetnek. */
  async resztvevoHozzaadas() {
    if (!this.reszletek?.jog?.kezelheti) return;
    const alert = await this.alertCtrl.create({
      header: 'Résztvevő hozzáadása',
      message: 'Kit veszel fel?',
      buttons: [
        { text: 'Iskolai tanuló', handler: () => { this.tanuloHozzaadas(); } },
        { text: 'Egész osztály / csoport', handler: () => { this.egysegHozzaadas(); } },
        { text: 'Külsős (név beírásával)', handler: () => { this.kulsosHozzaadas(); } },
        { text: 'Mégse', role: 'cancel' },
      ],
    });
    await alert.present();
  }

  async kulsosHozzaadas() {
    const alert = await this.alertCtrl.create({
      header: 'Külsős résztvevő',
      message: 'Pl. végzett diák, szülő, kísérő. A név kötelező, a megjegyzés nem.',
      inputs: [
        { name: 'nev', type: 'text', placeholder: 'Név', attributes: { maxlength: 150 } },
        { name: 'megjegyzes', type: 'text', placeholder: 'Megjegyzés (pl. végzett 2025, szülő, telefon)', attributes: { maxlength: 255 } },
      ],
      buttons: [
        { text: 'Mégse', role: 'cancel' },
        {
          text: 'Hozzáadás',
          handler: (v: any) => {
            const nev = String(v?.nev || '').trim();
            if (!nev) { this.data.sendToast('Írd be a nevét.', 'warning'); return false; }
            this.resztvevoFelvesz({ kulsosok: [{ nev, megjegyzes: String(v?.megjegyzes || '').trim() }] }, false);
            return true;
          },
        },
      ],
    });
    await alert.present();
  }

  /** Az intézmény tanulói (a „+" gomb és a kereső közös listája) – csak egyszer töltjük be. */
  private async tanulokBetolt(): Promise<boolean> {
    if (this.tanuloLista) return true;
    try {
      this.tanuloLista = await firstValueFrom(this.http.get<any[]>(
        '/api/tkt-befizetes/tanulok', { params: { intezmeny: this.intezmeny } }));
      return true;
    } catch (err) {
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült betölteni a tanulók listáját.'), 'error');
      return false;
    }
  }

  async tanuloHozzaadas() {
    if (!(await this.tanulokBetolt())) return;
    const bent = new Set(this.aktivResztvevok.map((r: any) => String(r.oktazon)));
    const items = (this.tanuloLista || [])
      .filter((t: any) => !bent.has(String(t.oktazon)))
      .map((t: any) => ({ id: String(t.oktazon), label: t.nev, sublabel: t.osztaly || 'nincs aktív osztály' }))
      //  Ábécérendben – a kiszolgáló a nyilvántartás sorrendjében adja.
      .sort((a: any, b: any) => String(a.label || '').localeCompare(String(b.label || ''), 'hu'));
    const modal = await this.modalCtrl.create({
      component: EntityPickerModalComponent,
      componentProps: {
        title: 'Résztvevők hozzáadása',
        searchPlaceholder: 'Tanuló neve vagy osztálya…',
        multiple: true,
        selectedIds: [],
        items,
      },
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role !== 'confirm' || !data?.ids?.length) return;
    await this.resztvevoFelvesz({ oktazonok: data.ids.map((x: any) => String(x)) }, false);
  }

  /*  EGÉSZ OSZTÁLY VAGY CSOPORT (#1092 – pl. a teljes évfolyam kirándul). A tagság a
   *  tevékenység napjára szól; a már felvett tanulók kimaradnak, a többiek a szokásos
   *  felvételi úton mennek (férőhely-figyelmeztetéssel). */
  async egysegHozzaadas() {
    let egysegek: any;
    try {
      egysegek = await firstValueFrom(this.http.get<any>('/api/tkt-befizetes/egysegek',
        { params: { intezmeny: this.intezmeny, esemeny: this.f?.id || '' } }));
    } catch (err) {
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült betölteni az osztályokat és csoportokat.'), 'error');
      return;
    }
    const bent = new Set(this.aktivResztvevok.map((r: any) => String(r.oktazon)));
    const osszes = [...(egysegek?.osztalyok || []), ...(egysegek?.csoportok || [])];
    const tagok = new Map(osszes.map((e: any) => [`${e.tipus}:${e.id}`, (e.tagok || []).map(String)]));
    const items = osszes.map((e: any) => {
      const uj = (e.tagok || []).filter((o: any) => !bent.has(String(o))).length;
      return { id: `${e.tipus}:${e.id}`, label: e.nev,
               sublabel: `${e.tipus === 'osztaly' ? 'osztály' : 'csoport'} · ${e.tagok.length} fő`
                 + (uj < e.tagok.length ? ` (${e.tagok.length - uj} már résztvevő)` : '') };
    });
    const modal = await this.modalCtrl.create({
      component: EntityPickerModalComponent,
      componentProps: {
        title: 'Osztály vagy csoport hozzáadása',
        searchPlaceholder: 'Osztály vagy csoport neve…',
        multiple: true,
        selectedIds: [],
        items,
      },
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role !== 'confirm' || !data?.ids?.length) return;
    const oktazonok = [...new Set(data.ids.flatMap((id: any) => tagok.get(String(id)) || []))]
      .filter((o: any) => !bent.has(String(o))) as string[];
    if (!oktazonok.length) { this.data.sendToast('A kiválasztottak tagjai már mind résztvevők.', 'info'); return; }
    await this.resztvevoFelvesz({ oktazonok }, false);
  }

  /*  A FÉRŐHELY FIGYELMEZTET, DE NEM TILT. Túllépésnél a kiszolgáló 409-cel felel a
   *  számokkal, mi rákérdezünk, és megerősítés után felülbírálva küldjük újra. */
  private async resztvevoFelvesz(tetel: { oktazonok?: string[], kulsosok?: any[] }, felulbiral: boolean) {
    await this.data.showLoading('Mentés...');
    try {
      const valasz: any = await firstValueFrom(this.http.post(
        `/api/tkt-befizetes/esemeny/${encodeURIComponent(this.f.id)}/resztvevok`,
        { intezmeny: this.intezmeny, oktazonok: tetel.oktazonok || [], kulsosok: tetel.kulsosok || [], felulbiral }));
      await this.data.hideLoading();
      const db = (valasz?.hozzaadva || []).length;
      this.data.sendToast(db
        ? `${db} résztvevő felvéve${valasz?.tullepes ? ' – a férőhelyen felül' : ''}.`
        : 'A kiválasztott tanulók már résztvevők.', db ? 'success' : 'info');
      await this.betoltReszletek();
    } catch (err: any) {
      await this.data.hideLoading();
      if (err?.status === 409 && err?.error?.tullepes) {
        const alert = await this.alertCtrl.create({
          header: 'Betelt a férőhely',
          message: `${err.error.error} Mégis felveszed?`,
          buttons: [
            { text: 'Mégse', role: 'cancel' },
            { text: 'Felveszem', handler: () => { this.resztvevoFelvesz(tetel, true); } },
          ],
        });
        await alert.present();
        return;
      }
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült felvenni a résztvevőt.'), 'error');
    }
  }

  async resztvevoLevesz(r: any) {
    const befizetett = (r?.befizetesek || []).length;
    const alert = await this.alertCtrl.create({
      header: 'Résztvevő levétele',
      message: befizetett
        ? `${r.nev} már ${befizetett} részletet befizetett. A befizetései megmaradnak, „korábbi résztvevő" jelöléssel – a visszafizetést negatív részletként lehet rögzíteni. Leveszed?`
        : `Biztosan leveszed ${r.nev} ${r.kulsos ? 'külsős résztvevőt' : 'tanulót'} a résztvevők közül?`,
      buttons: [
        { text: 'Mégse', role: 'cancel' },
        { text: 'Levétel', role: 'destructive', handler: () => { this.resztvevoLevetel(r, befizetett > 0); } },
      ],
    });
    await alert.present();
  }

  private async resztvevoLevetel(r: any, megerosit: boolean) {
    await this.data.showLoading('Mentés...');
    try {
      await firstValueFrom(this.http.delete(
        `/api/tkt-befizetes/esemeny/${encodeURIComponent(this.f.id)}/resztvevok/${encodeURIComponent(r.oktazon)}`,
        { params: { intezmeny: this.intezmeny, ...(megerosit ? { megerosit: '1' } : {}) } }));
      await this.data.hideLoading();
      this.data.sendToast('Résztvevő levéve.', 'success');
      await this.betoltReszletek();
    } catch (err: any) {
      await this.data.hideLoading();
      //  Közben rögzítettek neki befizetést: a kiszolgáló megerősítést kér.
      if (err?.status === 409 && err?.error?.befizetesVan && !megerosit) {
        await this.betoltReszletek();
        const friss = (this.reszletek?.resztvevok || []).find((x: any) => x.oktazon === r.oktazon) || r;
        return this.resztvevoLevesz(friss);
      }
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült levenni a résztvevőt.'), 'error');
    }
  }

  reszletNyit(r: any) {
    if (this.nyitottResztvevo === r.oktazon) { this.nyitottResztvevo = null; return; }
    this.nyitottResztvevo = r.oktazon;
    //  Az összeg alapból a hátralék: a leggyakoribb eset az, hogy a következő részlet jön.
    this.ujReszlet = { datum: this.maiNap(), osszeg: r?.hatralek > 0 ? r.hatralek : null, megjegyzes: '' };
  }

  async reszletRogzit(r: any) {
    const osszeg = Number(String(this.ujReszlet.osszeg ?? '').replace(/\s/g, '').replace(',', '.'));
    if (!this.ujReszlet.datum) { this.data.sendToast('Add meg a befizetés dátumát.', 'warning'); return; }
    if (!Number.isFinite(osszeg) || osszeg === 0) { this.data.sendToast('Add meg a befizetett összeget.', 'warning'); return; }
    await this.data.showLoading('Mentés...');
    try {
      const valasz: any = await firstValueFrom(this.http.post(
        `/api/tkt-befizetes/esemeny/${encodeURIComponent(this.f.id)}/befizetesek`,
        { intezmeny: this.intezmeny, oktazon: r.oktazon, datum: this.ujReszlet.datum, osszeg,
          megjegyzes: this.ujReszlet.megjegyzes || '', ertesites: !r.kulsos && this.reszletErtesites }));
      await this.data.hideLoading();
      const e = valasz?.ertesites;
      this.data.sendToast(e && !e.hiba && (e.email_db || e.uzenet_db)
        ? `Befizetés rögzítve, a tanuló értesítést kapott${e.email_db ? ' e-mailben' : ''}${e.uzenet_db ? (e.email_db ? ' és' : '') + ' SULINFORM-üzenetben' : ''}.`
        : (e?.hiba ? 'Befizetés rögzítve, de az értesítés nem ment ki.' : 'Befizetés rögzítve.'), e?.hiba ? 'warning' : 'success');
      await this.betoltReszletek();
      const friss = (this.reszletek?.resztvevok || []).find((x: any) => x.oktazon === r.oktazon);
      this.ujReszlet = { datum: this.maiNap(), osszeg: friss?.hatralek > 0 ? friss.hatralek : null, megjegyzes: '' };
    } catch (err) {
      await this.data.hideLoading();
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült rögzíteni a befizetést.'), 'error');
    }
  }

  async reszletTorol(r: any, b: any) {
    const alert = await this.alertCtrl.create({
      header: 'Befizetés törlése',
      message: `Törlöd ${r.nev} ${b.datum} napi, ${this.osszeg(b.osszeg, b.penznem)} összegű befizetését?`,
      buttons: [
        { text: 'Mégse', role: 'cancel' },
        {
          text: 'Törlés', role: 'destructive', handler: async () => {
            try {
              await firstValueFrom(this.http.delete(`/api/tkt-befizetes/befizetesek/${b.id}`,
                { params: { intezmeny: this.intezmeny } }));
              this.data.sendToast('Befizetés törölve.', 'success');
              await this.betoltReszletek();
            } catch (err) {
              this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült törölni a befizetést.'), 'error');
            }
          },
        },
      ],
    });
    await alert.present();
  }

  /*  TÁBLÁZATOS KIVITEL (CSV). Pontosvesszővel és BOM-mal, hogy a magyar Excel
   *  ékezethelyesen, oszlopokra bontva nyissa meg; tizedesvessző a számokban. */
  /*  A SZÜLŐK ADATAI a résztvevőkhöz (név, rokonság, e-mail, telefon) – a CSV és a PDF
   *  ugyanebből dolgozik, hogy a két export ne mondjon mást (Rinth Krisztina, 2026-11-02).
   *  Külsős résztvevőnek nincs tanulói adata: náluk a felvételkor megadott megjegyzés áll. */
  private async szuloAdatok(oktazonok: string[]): Promise<Map<string, { szulok: any[]; nev?: string; osztaly?: string }>> {
    const kulsosE = (k: string) => /^k:[0-9a-f]{12}$/.test(String(k));
    const tanulok = oktazonok.filter((o) => !kulsosE(o));
    const sorok: any[] = tanulok.length ? await firstValueFrom(this.http.post<any[]>(
      `/api/tkt/resztvevok/${this.sajatIntezmeny.intezmenyId}`, { oktazonok: tanulok })) : [];
    const m = new Map<string, { szulok: any[]; nev?: string; osztaly?: string }>();
    for (const r of sorok || []) {
      m.set(String(r.oktazon), { szulok: Array.isArray(r.szulok) ? r.szulok : [], nev: r.full_name, osztaly: r.osztaly });
    }
    for (const k of oktazonok.filter(kulsosE)) {
      const r = (this.reszletek?.resztvevok || []).find((x: any) => x.oktazon === k);
      m.set(k, { szulok: r?.megjegyzes ? [{ nev: r.megjegyzes }] : [] });
    }
    return m;
  }

  /** A szülők egy cellában: soronként egy (CSV-ben „ | ” választja el). */
  private static szuloCella(szulok: any[], mezo: 'nev' | 'email' | 'telefon', elvalaszto = '\n'): string {
    if (mezo === 'nev') {
      return (szulok || []).map((p) => [p.rokonsag, p.nev].filter(Boolean).join(': ')).filter(Boolean).join(elvalaszto);
    }
    return (szulok || []).map((p) => p[mezo]).filter(Boolean).join(elvalaszto);
  }

  async csvLetoltes() {
    const e = this.reszletek?.esemeny;
    if (!e) return;
    const szam = (v: any) => (v === null || v === undefined || v === '') ? '' : String(v).replace('.', ',');
    const mezo = (v: any) => {
      const t = String(v ?? '');
      return /[";\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
    };
    let szulok = new Map<string, { szulok: any[] }>();
    try {
      szulok = await this.szuloAdatok((this.reszletek.resztvevok || []).map((r: any) => String(r.oktazon)));
    } catch (err) {
      this.data.sendToast(this.hibaUzenet(err, 'A szülők adatai nem jöttek meg – a CSV nélkülük készült.'), 'warning');
    }
    const fej = ['Tanuló', 'Oktatási azonosító', 'Osztály', 'Szülő/gondviselő', 'E-mail', 'Telefon',
      'Állapot', 'Ár', 'Befizetve', 'Hátralék', 'Pénznem', 'Részletek'];
    const sorok = (this.reszletek.resztvevok || []).map((r: any) => {
      const sz = szulok.get(String(r.oktazon))?.szulok || [];
      return [
        r.nev, r.kulsos ? '' : r.oktazon, r.kulsos ? 'külsős' : (r.osztaly || ''),
        TktComponent.szuloCella(sz, 'nev', ' | '), TktComponent.szuloCella(sz, 'email', ' | '),
        TktComponent.szuloCella(sz, 'telefon', ' | '),
        this.allapotCimke(r),
        szam(r.ar), szam(r.befizetve), szam(r.hatralek), r.penznem || e.ar_penznem,
        (r.befizetesek || []).map((b: any) => `${b.datum}: ${szam(b.osszeg)}${b.megjegyzes ? ` (${b.megjegyzes})` : ''}`).join(' | '),
      ];
    });
    const csv = '\uFEFF' + [fej, ...sorok].map((sor) => sor.map(mezo).join(';')).join('\r\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const a = document.createElement('a');
    const safeName = String(e.nev || 'tevekenyseg').replace(/[^\p{L}\p{N}]+/gu, '_').replace(/^_+|_+$/g, '');
    a.href = url;
    a.download = `${safeName || 'tevekenyseg'}_befizetesek.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  /* ── Tanuló-kereső ─────────────────────────────────────────────────────── */

  /** Ékezet- és kisbetű-független összevetéshez. */
  private static egyszerusit(v: any): string {
    return String(v ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  /** A begépelt névre illő tanulók (legfeljebb 8) – a szavak bármilyen sorrendben. */
  get keresoJavaslatok(): any[] {
    const szavak = TktComponent.egyszerusit(this.kereso).split(/\s+/).filter(Boolean);
    if (this.keresoTanulo || !szavak.length || szavak.join('').length < 2 || !this.tanuloLista) return [];
    return this.tanuloLista
      .filter((t: any) => {
        const nev = TktComponent.egyszerusit(`${t.nev} ${t.osztaly || ''}`);
        return szavak.every((sz) => nev.includes(sz));
      })
      .sort((a: any, b: any) => String(a.nev || '').localeCompare(String(b.nev || ''), 'hu'))
      .slice(0, 8);
  }

  async keresoGepel() {
    if (this.keresoTanulo) { this.keresoTanulo = null; this.keresoTetelek = []; }
    if (TktComponent.egyszerusit(this.kereso).length >= 2) await this.tanulokBetolt();
  }

  async keresoValaszt(t: any) {
    this.keresoTanulo = t;
    this.kereso = t.nev;
    this.keresoTetelek = [];
    this.keresoToltes = true;
    try {
      const v = await firstValueFrom(this.http.get<any>(
        `/api/tkt-befizetes/tanulo/${encodeURIComponent(t.oktazon)}`, { params: { intezmeny: this.intezmeny } }));
      this.keresoTanulo = { ...t, ...(v?.tanulo || {}) };
      this.keresoTetelek = v?.tetelek || [];
    } catch (err) {
      this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült lekérni a tanuló tevékenységeit.'), 'error');
    } finally {
      this.keresoToltes = false;
    }
  }

  keresoTorles() {
    this.kereso = '';
    this.keresoTanulo = null;
    this.keresoTetelek = [];
  }

  /** A találat tevékenysége a szokásos ablakban – a listából, ha ott van (elmúlt is lehet). */
  keresoNyit(t: any) {
    const f = (this.feljegyzesek || []).find((x: any) => String(x.id) === String(t.esemeny?.id));
    this.openFeljegyzes(f || { ...t.esemeny });
  }

  /* ── Családi nézet ─────────────────────────────────────────────────────── */

  async betoltSajatBefizetesek() {
    try {
      const valasz: any = await firstValueFrom(this.http.get('/api/tkt-befizetes/sajat', {
        params: { intezmeny: this.intezmeny, felhasznalo: String(this.uuid || '') },
      }));
      this.sajatBefizetesek = Array.isArray(valasz?.tetelek) ? valasz.tetelek : [];
    } catch (err) {
      this.sajatBefizetesek = [];
      console.warn('A befizetések nem tölthetők be:', err);
    }
  }

  get tobbGyerek(): boolean {
    return new Set((this.sajatBefizetesek || []).map((t: any) => t.tanulo?.oktazon)).size > 1;
  }

  /*  Ugyanaz a szűrő, mint a listán: alapból ami még nem ért véget – de a nyitott
   *  hátralék akkor is látszik, ha a tábor már lezajlott. */
  get lathatoSajatBefizetesek(): any[] {
    const lista = this.sajatBefizetesek || [];
    if (!this.elmultakIs) {
      const ma = new Date(); ma.setHours(0, 0, 0, 0);
      return lista.filter((t: any) => {
        const d = this.zaras(t.esemeny);
        return !d || d >= ma || Number(t.hatralek) > 0;
      });
    }
    return lista.filter((t: any) => {
      const d = this.zaras(t.esemeny);
      return d ? TktComponent.tanevKezdete(d) === Number(this.tanev) : true;
    });
  }

  sajatTetelek(f: any): any[] {
    return (this.sajatBefizetesek || []).filter((t: any) => String(t.esemeny?.id) === String(f?.id));
  }

  private safeParseJson(value: any, fallback: any = []) {
    if (value === null || value === undefined || value === '') return fallback;
    if (Array.isArray(value) || (typeof value === 'object' && value !== null)) return value;

    const raw = String(value).trim();
    const candidates = [
      raw,
      raw
        .replace(/,\s*,+/g, ',')
        .replace(/\[\s*,/g, '[')
        .replace(/,\s*\]/g, ']')
        .replace(/,\s*\}/g, '}'),
    ];

    for (const candidate of candidates) {
      try {
        return JSON.parse(candidate);
      } catch {
        // Try the next sanitized variant.
      }
    }

    console.warn('Hibás JSON mező a szakkör jelentkezésnél:', raw);
    return fallback;
  }

  private normalizeActivity(activity: any) {
    const jelentkezok = this.safeParseJson(activity?.jelentkezok, []);
    const jelentkezokArr = this.safeParseJson(activity?.jelentkezok_arr, {});

    //  Al-program (pl. a nyílt nap egy foglalkozása): a fő esemény nevével együtt értelmes.
    const nev = String(activity?.nev || '');
    const szulo = String(activity?.szulo_nev || '');
    return {
      ...activity,
      nev: szulo && !nev.startsWith(`${szulo} – `) ? `${szulo} – ${nev}` : nev,
      jelentkezok: Array.isArray(jelentkezok)
        ? [...new Set(jelentkezok.map((item) => String(item || '').trim()).filter(Boolean))]
        : [],
      jelentkezok_arr: jelentkezokArr && typeof jelentkezokArr === 'object' ? jelentkezokArr : {},
    };
  }

  /** A tevékenység vége (ha nincs, a kezdete) – ehhez mérjük, hogy elmúlt-e. */
  private zaras(f: any): Date | null {
    const v = f?.vege || f?.kezdes;
    if (!v) return null;
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  /** A listában felkínált tanévek – abból, ami tényleg van, nem tetszőleges tartományból. */
  get tanevek(): number[] {
    const keszlet = new Set<number>();
    for (const f of this.feljegyzesek || []) {
      const d = this.zaras(f);
      if (d) keszlet.add(TktComponent.tanevKezdete(d));
    }
    keszlet.add(TktComponent.tanevKezdete(new Date()));
    return [...keszlet].sort((a, b) => b - a);
  }

  tanevCimke(ev: number): string { return `${ev}/${String(ev + 1).slice(-2)}`; }

  get szurtFeljegyzesek(): any[] {
    const lista = this.feljegyzesek || [];
    if (!this.elmultakIs) {
      // „Még nincs vége": a ma is tartó program bent marad, a tegnap zárult kiesik.
      const ma = new Date(); ma.setHours(0, 0, 0, 0);
      return lista.filter((f) => {
        const d = this.zaras(f);
        return !d || d >= ma;
      });
    }
    return lista.filter((f) => {
      const d = this.zaras(f);
      return d ? TktComponent.tanevKezdete(d) === Number(this.tanev) : true;
    });
  }

  /** A tartalék névsor (ha a részletek nem jöttek meg) is ábécérendben. */
  get jelentkezokRendezve(): string[] {
    return [...(this.f?.jelentkezok || [])]
      .sort((a: string, b: string) => String(this.getApplicantName(a) || '').localeCompare(String(this.getApplicantName(b) || ''), 'hu'));
  }

  get jelentkezok(): string[] {
    return Array.isArray(this.f?.jelentkezok) ? this.f.jelentkezok : [];
  }

  isJelentkezett(oktazon: any): boolean {
    return this.jelentkezok.includes(String(oktazon));
  }

  setJelentkezes(gyerek: any, selected: boolean) {
    if (!this.f) return;

    const oktazon = String(gyerek?.oktazon || '').trim();
    if (!oktazon) return;

    const current = new Set(this.jelentkezok);
    if (selected) current.add(oktazon);
    else current.delete(oktazon);

    this.f.jelentkezok = [...current];
  }

  getApplicantName(oktazon: any): string {
    const key = String(oktazon || '').trim();
    const fromArr = this.f?.jelentkezok_arr?.[key];
    return fromArr?.name || fromArr?.full_name || fromArr?.nev || key;
  }

  isPedagogusMode(): boolean {
    const roles = [
      ...(Array.isArray((this.user$ as any)?.jogkor) ? (this.user$ as any).jogkor : []),
      ...(Array.isArray((this.user$ as any)?.realm_access?.roles) ? (this.user$ as any).realm_access.roles : []),
      ...(Array.isArray((this.user$ as any)?.roles) ? (this.user$ as any).roles : []),
    ].map((role) => String(role).toLowerCase());

    return this.loginMode === 'dolgozo'
      || roles.includes('pedagogus')
      || roles.includes('admin')
      || roles.includes('ig')
      || roles.includes('igh');
  }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims());
    this.loginMode = await this.data.getFromStorage("loginmode")

    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    //this.userMetadata.department = "rendszergazda"
    /*  A KILÉT NEVE: `preferred_username`, és csak tartalékként `username`. A Keycloak
     *  tokenjében `username` NINCS – csak akkor kerül bele, ha a belépés-bekötés vagy a
     *  nézetváltás átírja. Enélkül a gyerekek lekérése a „undefined” névre ment, a
     *  kiszolgáló 403-mal utasította el, és mivel a hívásnak nem volt hibaága, a képernyő
     *  csak pörgött (Zenit, szülői belépés, 2026-09-19). */
    this.uuid = String(this.user$?.preferred_username || this.user$?.username || '')
    await this.data.showLoading("Egy pillanat...")
    if (!this.isPedagogusMode()) this.betoltSajatBefizetesek();
    const listUrl = this.isPedagogusMode()
      ? `/api/tkt/lista/dolgozo/${this.sajatIntezmeny.intezmenyId}`
      : `/api/tkt/lista/publikus/${this.sajatIntezmeny.intezmenyId}`;

    /*  A TÖLTÉSJELZŐ MINDEN ÁGON LEZÁRUL. Eddig csak a legbelső sikeres ágban kapcsoltuk
     *  ki: egyetlen hibás válasz (403, 500) örökre pörgő képernyőt hagyott maga után. */
    try {
      const lista: any = await firstValueFrom(this.http.get(listUrl)).catch((err) => {
        this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült betölteni a programokat.'), 'error');
        return [];
      });
      this.feljegyzesek = Array.isArray(lista) ? lista.map((d) => this.normalizeActivity(d)) : [];

      if (!this.isPedagogusMode() && this.uuid) {
        this.gyerekek = await firstValueFrom(this.http.get<any[]>(
          '/api/nyilvantartas/szulogyereke/' + encodeURIComponent(this.uuid) + '/' + this.sajatIntezmeny.intezmenyId
        )).catch((err) => {
          this.data.sendToast(this.hibaUzenet(err, 'Nem sikerült betölteni a gyermekeidet.'), 'error');
          return [];
        }) || [];
      }
    } finally {
      await this.data.hideLoading()
    }

  }

  async confirm() {
    this.close()
    await this.data.showLoading("Mentés...")
    // Backend végpont: a férőhely/határidő/biztonsági ellenőrzés szerveroldalon.
    const sajat = (this.gyerekek || []).map(o => String(o.oktazon || '').trim()).filter(Boolean);
    const intezmeny = String(this.sajatIntezmeny.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    this.http
      .post(`/api/tanevrendje/jelentkezes/${this.f.id}`,
        { intezmeny, sajat, jelentkezok: this.jelentkezok })
      .subscribe({
        next: async () => {
          await this.data.hideLoading()
          await this.ngOnInit()
        },
        error: async (err) => {
          await this.data.hideLoading()
          this.data.sendToast(err?.error?.error || "Nem sikerült menteni a jelentkezést.", "error")
        },
      });
  }

  close() {
    this.feljegyzesmodal.dismiss()
  }
  openFeljegyzes(f) {
    this.f = this.normalizeActivity(f)
    this.reszletek = null
    this.nyitottResztvevo = null
    this.feljegyzesmodal.present()
    // Munkatársnál a résztvevők (és kezelőnek a befizetések) a kiszolgálótól jönnek.
    if (this.isPedagogusMode()) this.betoltReszletek()
  }

  async exportPdf() {
    if (!this.f) return;

    const oktazonok = this.jelentkezok;
    if (!oktazonok.length) {
      this.data.sendToast('Nincs jelentkező a PDF generálásához.', 'warning');
      return;
    }

    await this.data.showLoading('PDF készítése...');

    try {
      //  A külsős résztvevőnek (k:…) nincs tanulói adata: a nevét a résztvevő-listából vesszük.
      const kulsosE = (k: string) => /^k:[0-9a-f]{12}$/.test(String(k));
      const szulok = await this.szuloAdatok(oktazonok);
      const resztvevo = (k: string) => (this.reszletek?.resztvevok || []).find((x: any) => String(x.oktazon) === String(k));
      const rows: any[] = oktazonok.map((k) => {
        const r = resztvevo(k);
        const sz = szulok.get(String(k));
        return { oktazon: k, kulsos: kulsosE(k), full_name: sz?.nev || r?.nev || this.getApplicantName(k),
                 osztaly: kulsosE(k) ? 'külsős' : (sz?.osztaly || r?.osztaly || ''), szulok: sz?.szulok || [], r };
      }).sort((a: any, b: any) => String(a.full_name || '').localeCompare(String(b.full_name || ''), 'hu'));

      /*  PÉNZÜGY A PDF-BEN (Rinth Krisztina, 2026-11-02): a befizetett és a hátralévő összeg is
       *  – ugyanannak, aki a CSV-ben is látja (a tevékenység kezelője: szervező, pénztár, admin). */
      const penzugy = !!this.reszletek?.jog?.penzugy;
      const ft = (r: any, mezo: 'befizetve' | 'hatralek') =>
        (!r || r[mezo] === null || r[mezo] === undefined) ? '–' : this.osszeg(r[mezo], r.penznem || this.reszletek?.esemeny?.ar_penznem);

      const body = rows.map((row, index) => [
        String(index + 1),
        row.full_name,
        row.kulsos ? '' : String(row.oktazon || ''),
        row.osztaly || '',
        TktComponent.szuloCella(row.szulok, 'nev'),
        TktComponent.szuloCella(row.szulok, 'email'),
        TktComponent.szuloCella(row.szulok, 'telefon'),
        ...(penzugy ? [ft(row.r, 'befizetve'), ft(row.r, 'hatralek')] : []),
      ]);
      const head = ['#', 'Tanuló', 'Oktatási azonosító', 'Osztály', 'Szülő/gondviselő', 'Email', 'Telefon',
        ...(penzugy ? ['Befizetve', 'Hátralék'] : [])];
      const safeName = String(this.f.nev || 'szakkor').replace(/[^\p{L}\p{N}]+/gu, '_').replace(/^_+|_+$/g, '');
      const fajlnev = `${safeName || 'szakkor'}_jelentkezok.pdf`;
      const idopont = `${this.formatDate(this.f.kezdes)} - ${this.formatDate(this.f.vege)}`;
      const osz = this.reszletek?.osszesites || null;

      /*  A kiszolgáló riport-motorja (backend/pdf-riport.js, a munkaidő-elszámolás arculata);
       *  ha nem sikerül, a régi, böngészős PDF készül. */
      try {
        await this.data.riportPdf({
          intezmeny: this.sajatIntezmeny?.intezmenyId,
          cim: this.f.nev || 'Szakkör',
          cimKieg: 'jelentkezők',
          alcim: `Időpont: ${idopont}`,
          adatsav: [['Szakkör', this.f.nev || ''], ['Időpont', idopont], ['Jelentkezők', String(body.length)],
            ...(penzugy && this.f.ar ? [['Ár', this.arSzoveg(this.f)]] : []),
            ...(penzugy && osz ? [['Befizetve összesen', this.osszeg(osz.befizetve, osz.penznem)]] : []),
            ...(penzugy && osz && osz.hatralek !== null ? [['Hátralék összesen', this.osszeg(osz.hatralek, osz.penznem)]] : [])],
          lapmeret: 'A4', tajolas: 'fekvo', betumeret: 8.5,
          tablak: [{
            cim: 'Jelentkezők névsora', osszegzes: `${body.length} fő`,
            //  A régi oszlopszélességek (10/42/32/20/62/58/45 mm) arányai; pénzüggyel a szülői
            //  oszlopok szűkülnek a két összeg-oszlop javára.
            oszlopok: penzugy ? [
              { nev: head[0], igazitas: 'kozep', szelesseg: '3.4%' }, { nev: head[1], szelesseg: '14%' },
              { nev: head[2], igazitas: 'bal', szelesseg: '10.4%' }, { nev: head[3], szelesseg: '6.4%' },
              { nev: head[4], szelesseg: '19%' }, { nev: head[5], szelesseg: '18%' }, { nev: head[6], igazitas: 'bal', szelesseg: '12.8%' },
              { nev: head[7], igazitas: 'jobb', szelesseg: '8%' }, { nev: head[8], igazitas: 'jobb', szelesseg: '8%' },
            ] : [
              { nev: head[0], igazitas: 'kozep', szelesseg: '3.7%' }, { nev: head[1], szelesseg: '15.5%' },
              { nev: head[2], igazitas: 'bal', szelesseg: '11.8%' }, { nev: head[3], szelesseg: '7.4%' },
              { nev: head[4], szelesseg: '23%' }, { nev: head[5], szelesseg: '21.9%' }, { nev: head[6], igazitas: 'bal', szelesseg: '16.7%' },
            ],
            sorok: body.map((s) => [s[0], { t: s[1], fej: true }, ...s.slice(2)]),
          }],
          lablec: { kelt: true },
          fajlnev,
        }, fajlnev, 'letolt');
        return;
      } catch (e: any) {
        console.warn('Szakkör-névsor PDF (kiszolgáló) hiba, böngészős tartalék:', e);
        this.data.sendToast(`A PDF a régi formában készült (${e?.message || e}).`, 'warning');
      }

      const pdf = new jsPDF('l', 'mm', 'a4');
      pdf.addFileToVFS('Bitter-Regular-normal.ttf', font);
      pdf.addFont('Bitter-Regular-normal.ttf', 'Bitter-Regular', 'normal');
      pdf.addFileToVFS('Bitter-Bold-normal.ttf', fontB);
      pdf.addFont('Bitter-Bold-normal.ttf', 'Bitter-Bold', 'bold');
      pdf.setFont('Bitter-Regular');
      pdf.setFontSize(14);
      pdf.text(`${this.f.nev || 'Szakkör'} - jelentkezők`, 14, 14);
      pdf.setFontSize(9);
      pdf.text(`Időpont: ${idopont}`, 14, 21);

      autoTable(pdf, {
        startY: 28,
        head: [head],
        body,
        theme: 'grid',
        styles: { font: 'Bitter-Regular', fontSize: 8, overflow: 'linebreak', valign: 'middle' },
        headStyles: { fillColor: [56, 128, 255], font: 'Bitter-Bold', fontStyle: 'bold' },
        columnStyles: penzugy ? {
          0: { cellWidth: 9, halign: 'center' },
          1: { cellWidth: 38 },
          2: { cellWidth: 28 },
          3: { cellWidth: 17 },
          4: { cellWidth: 51 },
          5: { cellWidth: 48 },
          6: { cellWidth: 34 },
          7: { cellWidth: 22, halign: 'right' },
          8: { cellWidth: 22, halign: 'right' },
        } : {
          0: { cellWidth: 10, halign: 'center' },
          1: { cellWidth: 42 },
          2: { cellWidth: 32 },
          3: { cellWidth: 20 },
          4: { cellWidth: 62 },
          5: { cellWidth: 58 },
          6: { cellWidth: 45 },
        },
      });

      pdf.save(fajlnev);
    } catch (error) {
      console.error('Szakkör PDF generálási hiba:', error);
      this.data.sendToast('Nem sikerült elkészíteni a PDF-et.', 'error');
    } finally {
      await this.data.hideLoading();
    }
  }

  private formatDate(value: any): string {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString('hu-HU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

}
